<template>
    <div style="cursor: pointer">
      <div>
        <div v-for="i in listData" :key="i" class="pcgl-btn" @click="onCellClick(row)">
          <el-tooltip :offset="1000" :disabled="!disabled" placement="top" :content="i.fileName||i.name">
            <div ref="isOverflow" :key="i" class="tooltip" @mouseover="mouseover">
              <span><img :src="imgUrl(i)" style="width: 16px;position: relative;top: 4px;margin: 0 10px;" alt="">{{ i.fileName||i.name }}</span>
            </div>
          </el-tooltip>
        </div>
      </div>
      <!-- <el-dialog v-if="tableShow" v-el-drag-dialog append-to-body title="压缩包" :visible.sync="tableShow" width="1000px" :close-on-click-modal="false">
        <div style="overflow-y:hidden;border: 1px solid #d8dce5;">
          <div style="min-height:300px;max-height: 500px;overflow-y: auto;">
            <GiantTree v-if="treeData.length>0" ref="tree" style="padding:0 10px" node-key="id" :filter-node-method="filterNode" :nodes="treeData" @onCreated="onTreeCreated" @onClick="onTreeNodeClick" @onExpand="treeBeforeExpand">
              <template #context-menu="slotProps">
                <ul>
                  <li @click="editMenu(slotProps.contextNode,'下载')">下载</li>
                </ul>
              </template>
            </GiantTree>
            <div v-else style="text-align:center;margin-top:30px;">
              <img src="images/w-imgs/nomessage.png" style="max-width:180px"><br>
              <span style="font-size:15px;color:#dbdbdb">此压缩包为空。</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button :icon="'el-icon-close'" @click="tableShow=false">关 闭</el-button>
        </span>
      </el-dialog> -->
    </div>
  </template>

<script>
export default {
    props: {
        column: { type: Object, default: null },
        row: { type: Object, default: null },
        index: { type: Number, default: null }
    },
    data() {
        return {
            editBtn: false,
            listData: [],
            downloadUrl: '/dagl/xmzlFile/downloadById',
            tableShow: false,
            downloadUrlZip: '/disk/file/downloadZipId',
            treeData: [],
            id: '',
            disabled: false
        }
    },
    watch: {
        'row': {
            handler(val) {
                this.listData = []
                this.listData.push(val)
                // this.getConent()
            },
            deep: true
        }
    },
    created() {
        // `images/w-imgs/email/${i.type==='ATTACH'?'pdf':''}pdf.png`"
        this.listData.push(this.row)

        // eslint-disable-next-line no-undef
    },
    mounted() {
        // this.$nextTick(() => {
        //     this.getConent()
        // })
    },
    beforeDestroy() {
    },
    methods: {
        mouseover() {
            this.getConent()
        },
        getConent(row) {
            // 文字超出显示tooltip 不超出不显示 判断文字是否超出div宽度
            if (this.$refs.isOverflow) {
                const isOverflow = this.$refs.isOverflow[0]
                const cWidth = isOverflow.clientWidth
                const sWidth = isOverflow.scrollWidth
                if (sWidth > cWidth) { // 超过
                    this.disabled = true
                } else {
                    this.disabled = false
                }
            }
        },
        // 下载
        editMenu(row, type) {
            console.log(row, type, 'row', this.row)
            if (!row.fullId) return
            window.open(
                process.env.VUE_APP_BASE_API +
                  `${this.downloadUrlZip}?inline=true&fileId=${this.id}&fileNames=${row.fullId}&saveAs=${row.fileName}`
            )
        },
        onTreeCreated(zTree) {
            this.zTree = zTree
            const treeObj = this.zTree// 获取树
            const treenodes = treeObj.getNodes()// 人员所在机构的树节点
            if (treenodes.length > 0) {
                this.$nextTick(() => {
                    this.onTreeNodeClick('', treenodes[0].id, treenodes[0])// 获取节点数据
                    treeObj.selectNode(treenodes[0])// 选中当前节点
                    treeObj.expandNode(treenodes[0], true, false, true)
                })
            }
        },
        onTreeNodeClick(evt, treeId, treeNode) {
            this.treeNode = treeNode
        },
        treeDataAdapter(treeData) {
            treeData.forEach(node => {
                if (!node.parentId) {
                    node.pId = '0'
                } else {
                    node.pId = node.parentId
                }
                node.title = node.name = node.fileId + `\xa0\xa0\xa0${node.fileSize}`
                // 默认展开节点
                // node.open = true
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        },
        // 预览
        onCellClick(row) {
            // const api_url = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port
            // let href = ''
            // if (row.name.split('.')[1] === 'pdf') {
            //     href = api_url + '/apigw/disk/file/download?id=' + row.id + '&inline=true&dataField=fileData&nameField=fileName&fileName=' + row.name
            // } else {
            //     href = api_url + '/apigw/disk/file/download?id=' + row.id + '&inline=true&toPdf=true&dataField=fileData&nameField=fileName&fileName=' + row.name
            // }

            // window.open('./plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(href))

            console.log(this.$vnode.context.$vnode.context.moduleClass, 'vwfilefolder', '文件管理', 'vwreaderfile', '分享给我', 'vwsharefile', '我分享的', 'vwcollectfile', '我收藏的')
            // 文件夹
            var id = ''
            var ids = ''
            var name = ''
            var type = row.type
            id = row.id
            name = row.fileName
            ids = row.downId
            this.id = id

            if (Number(row.flType) === 2) {
                // 打开目录

                this.$bus.emit('setListDataUrl', row.id, row)
            } else {
                // 文件
                // if (!row.id) return
                // window.open('./plugins/PDFjs/web/viewer.html?file=' +encodeURIComponent(window.location.protocol + '//' + window.location.host + process.env.VUE_APP_BASE_API + `${this.downloadUrl}?inline=true&attachIds=` + id + '&fileName=' + name))

                if (name.indexOf('.ofd') > -1) {
                    let downUrl = process.env.VUE_APP_BASE_API + this.downloadUrl + '?inline=true&attachIds=' + id + '&fileName=' + name + '&saveAs=' + name
                    window.open('./plugins/OfdJs/view.html?file=' + encodeURIComponent(downUrl))
                } else {
                    window.open(process.env.VUE_APP_BASE_API + `${this.downloadUrl}?inline=true&attachIds=` + id + '&saveAs=' + name)
                }
            }
        },
        // 返回图片路径
        imgUrl(item) {
            if (Number(item.flType) === 2) {
                // 文件夹类型
                return 'images/w-imgs/email/folder.png'
            } else {
                var extension = item.fileName || item.name
                extension = extension.substring(extension.lastIndexOf('.'))
                if (extension === '.doc' || extension === '.docx') {
                    return 'images/w-imgs/email/word.png'
                }
                if (extension === '.ppt' || extension === '.pptx') {
                    return 'images/w-imgs/email/ppt.png'
                }
                if (extension === '.xls' || extension === '.xlsx') {
                    return 'images/w-imgs/email/excel.png'
                }
                if (extension === '.pdf') {
                    return 'images/w-imgs/email/pdf.png'
                }
                if (extension === '.txt') {
                    return 'images/w-imgs/email/txt.png'
                }
                if (extension === '.zip' || extension === '.rar') {
                    return 'images/w-imgs/email/zip.png'
                }
                if (extension === '.jpg' || extension === '.jpeg' || extension === '.png' || extension === '.gif') {
                    return 'images/w-imgs/email/picture.png'
                } else {
                    return 'images/w-imgs/email/其他.png'
                }
            }
        }

    }}
</script>

  <style scoped lang="scss">
  .pcgl-btn .el-button{
  cursor: pointer;
  padding: 0px 7px;
  }
  .clgl-sendcar,.clgl-sendcarD {
  color: #333;
  }
  .clgl-sendcarD:hover {
  color: #409EFF;
  }
  .tooltip{
      width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  }
  </style>
